import React from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from '../landing/LandingPage';
import { isDesktopUserAgent } from '../../utils/userAgent';

/**
 * Component that renders the appropriate landing page based on domain
 */
const SentryRootRoute: React.FC = () => {
  // Check if we're on the Sentry domain
  const isSentryDomain = 
    typeof window !== 'undefined' && 
    (window.location.hostname === 'sentry.trading' || 
     window.location.hostname === 'www.sentry.trading');

  if (!isSentryDomain) {
    return <LandingPage />;
  }

  return isDesktopUserAgent()
    ? <Navigate to="/sentry-desktop" replace />
    : <Navigate to="/sentry-pwa" replace />;
};

export default SentryRootRoute;
